// eslint-disable-next-line import/no-extraneous-dependencies
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rolePopupOpen: { status: '', role: '' },
  deletePopupOpen: false,
  invitePopupOpen: false,
  successPopupOpen: false,
  peopleListDispaly: false,
  roleDropdown: { roleType: 'User' },
  trackDropdown: { contentType: 'AnywhereWorks' },
  dropdownVictimUser: {},
  updateRole: null,
  deletePeople: null,
  currentUser: {},
  dropdownType: null
};

export const people = createSlice({
  name: 'people',
  initialState,
  reducers: {
    updateDropdownType: (state, action) => {
      state.dropdownType = action.payload;
    },
    updateDropdownVictimUser: (state, action) => {
      state.dropdownVictimUser = action.payload;
    },
    updateRole: (state, action) => {
      state.updateRole = action.payload;
    },
    deletePeople: (state, action) => {
      state.deletePeople = action.payload;
    },
    updateCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    }
  }
});

export const {
  updateDropdownVictimUser,
  updateRole,
  deletePeople,
  updateCurrentUser,
  updateDropdownType
} = people.actions;

export default people.reducer;
